import React from "react";

const ProgressTracker = ({ currentDay, totalDays }) => {
  const progressPercentage = (currentDay / totalDays) * 100;

  return (
    <div style={styles.container}>
      <p style={styles.text}>
        Day {currentDay} of {totalDays}
      </p>
      <div style={styles.progressBarContainer}>
        <div
          style={{
            ...styles.progressBar,
            width: `${progressPercentage}%`,
          }}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    margin: "20px 0",
    textAlign: "center",
  },
  text: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  progressBarContainer: {
    width: "100%",
    height: "20px",
    backgroundColor: "#e0e0e0",
    borderRadius: "10px",
    overflow: "hidden",
    marginTop: "10px",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#4caf50",
    borderRadius: "10px",
    transition: "width 0.5s ease-in-out",
  },
};

export default ProgressTracker;
